// src/components/RedirectPuzzle.js
import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const RedirectPuzzle = () => {
  const { publicCode, stationId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!publicCode) return;

    // Persist the last visited bonus puzzle code so refreshes still work
    try {
      window.sessionStorage.setItem('fm_lastBonusPublicCode', publicCode);
      if (stationId) {
        window.sessionStorage.setItem('fm_lastBonusStationId', stationId);
      } else {
        window.sessionStorage.removeItem('fm_lastBonusStationId');
      }
    } catch {
      // Ignore storage errors (e.g., in private mode)
    }

    // Hide the actual code from the visible URL by navigating to /puzzle.
    // stationId is forwarded as state so jumpItOrFixIt puzzles know which
    // station the player just scanned.
    navigate('/puzzle', {
      replace: true,
      state: stationId ? { publicCode, stationId } : { publicCode },
    });
  }, [navigate, publicCode, stationId]);

  return <p>Loading puzzle...</p>;
};

export default RedirectPuzzle;
